import { Component, OnInit, forwardRef, Input, SimpleChanges, ViewChild, Output, EventEmitter, } from '@angular/core';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { 
    IonIcon
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

import { DemoozModalMediaComponent, DemoozButtonComponent } from '@demooz/components';
import { DataService, LanguagesService, OperationService } from '@app/services';
import { OperationNews } from '@app/models';

@Component({
    selector: 'app-news-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
    imports: [
        IonIcon, TranslatePipe, forwardRef(() => DemoozModalMediaComponent), forwardRef(() => DemoozButtonComponent)
    ]
})
export class NewsItemComponent  implements OnInit {
      
    @Input({alias : 'news', required : true}) news: OperationNews;
    @Output() onLikeNews = new EventEmitter<boolean>();
      
    @ViewChild('modalMedia') modalMedia: DemoozModalMediaComponent;
      
    title: string;
    description: SafeHtml;
    isLiked: boolean = false;
    isFetchingLike: boolean = false;
      
    constructor(        
        private domSanitizer: DomSanitizer,
        public dataService: DataService,
        private languagesService: LanguagesService,
        private operationService: OperationService
    ) { }

    ngOnInit() {
        
    }
        
    async ngOnChanges(changes: SimpleChanges) {
        if(changes['news'] && changes['news'].currentValue){
            this.initNews();
        }
    }
    
    initNews(){
        this.title = this.news.titles.getText(this.languagesService.actualLanguage);
        this.description = this.domSanitizer.bypassSecurityTrustHtml(this.news.descriptions.getText(this.languagesService.actualLanguage));
        this.isLiked = (this.news.likes?.find(l => l.ambassadorID === this.dataService.ambassador.value?.ID) !== undefined);
    }
    
    showNewsMedia(){
        if(this.news.url && this.news.url != ''){
            this.modalMedia.open(this.news.url);
        }
    }
    
    async likeNews(){        
        this.isFetchingLike = true;
        let status = await this.operationService.postLikeNews(this.dataService.operation.value.ID, this.news.ID, !this.isLiked);
        if(status){
            await this.operationService.refreshOperation();
            this.onLikeNews.emit(true);
        }
        this.isFetchingLike = false;        
    }
}
